var render = function (_h,_vm) {var _c=_vm._c;return _c('div',{class:['base-logo', _vm.props.theme]},[(_vm.props.small)?_c('img',{attrs:{"src":require("../assets/img/logo/LOGO_B_TAP.png")}}):_c('img',{attrs:{"src":require("../assets/img/logo/LOGO_B_SMALL.png")}})])}
var staticRenderFns = []

export { render, staticRenderFns }